
export enum AttendanceFormErrorsEnum {
    InvalidLinkErrorCode = "Invalid_Link",
    StartDateNullErrorCode = "StartDate_Null",
    EndDateNullErrorCode = "EndDate_Null",
    LinkExpiredErrorCode = "Link_Expired",
    InactiveLinkErrorCode = "Inactive_Link",
    EventNotAvailable = "Event_NotAvailable"
}
